import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "waybills-table-column-calculation-type" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bs_status = _resolveComponent("bs-status")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_bs_status, null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.calculationType), 1)
      ]),
      _: 1
    })
  ]))
}